import React, { PureComponent } from 'react';
import { Container, Row, Col } from 'react-grid-system';

import Select from 'components/cosmos/select';
import { I18n, translate } from 'components/translate';
import Number from 'helpers/Number';
import { ClassesService } from 'modules/content';
import { UserManagerService } from 'modules/userManager';
import PropTypes from 'prop-types';

import SearchFilter from '../../../components/input/search/SearchFilter';
import { modalTypes } from '../constants';
import ModalClass from '../modalClass/ModalClass';

import './ClassUsersHeader.scss';

@translate()
class ClassUsersHeader extends PureComponent {
  // #region set up
  static propTypes = {
    changeClass: PropTypes.func,
    changeUserType: PropTypes.func,
    classId: PropTypes.string,
    filters: PropTypes.object,
    handleChange: PropTypes.func,
    pagination: PropTypes.object,
    t: PropTypes.func
  };

  state = {
    classOptions: [],
    selectedClass: '',
    showModal: false
  };

  constructor(props) {
    super(props);

    this.userTypeOptions = UserManagerService.userTypeList;

    this.onModalCancel = this.onModalCancel.bind(this);
    this.onModalConfirm = this.onModalConfirm.bind(this);
    this.setSelectedClass = this.setSelectedClass.bind(this);
  }

  async componentDidMount() {
    const classes = await ClassesService.getSelectFormatedClasses();

    this.setState({
      classOptions: classes.filter(
        (mClass) => mClass.value !== this.props.classId
      )
    });
  }
  // #endregion

  // #region handlers
  setSelectedClass(selectedClass) {
    this.setState({ selectedClass, showModal: true });
  }

  onModalConfirm() {
    const { changeClass } = this.props;

    changeClass && changeClass(this.state.selectedClass);
    this.onModalCancel();
  }

  onModalCancel() {
    this.setState({ selectedClass: '', showModal: false });
  }
  // #endregion

  // #region render
  render() {
    const { filters, handleChange, changeUserType, t } = this.props;
    const { classOptions, selectedClass, showModal } = this.state;

    return (
      <div className="class__users__header">
        <h2>
          <I18n label="class_manager.class_editor.manage_your_class" />
        </h2>
        <p className="mb__md">
          <I18n label="class_manager.class_editor.manage_your_class_description" />
        </p>

        <Container fluid className="class__users__controls">
          <Row justify="between">
            <Col
              xs={12}
              sm={7}
              lg={8}
              className="class-header-column move-to-class"
            >
              <label>
                <I18n label="class_manager.users.move_users_to" />
              </label>

              <Select
                onChange={this.setSelectedClass}
                options={classOptions}
                value={selectedClass}
                placeholder={t('users_import.manually.class.placeholder')}
                className="_mb-0"
                data-test="select-change-class"
              />
            </Col>

            <Col
              xs={12}
              sm={5}
              lg={4}
              className="class-header-column users-quantity"
            >
              <label>
                <I18n label="general.quantity" />
              </label>
              {this.renderUsersAmount()}
            </Col>
          </Row>

          <Row justify="between">
            <Col xs={12} sm={7} lg={8} className="class-header-column">
              <SearchFilter>
                <SearchFilter.SearchInput
                  autoComplete="off"
                  classIcon="users__manager__search__filter__icon"
                  icon="search"
                  maxLength="120"
                  onChange={handleChange}
                  placeholder="users_manager.users_list.filter.input"
                />
              </SearchFilter>
            </Col>

            <Col xs={12} sm={5} lg={4} className="class-header-column">
              <Select
                onChange={changeUserType}
                options={this.userTypeOptions}
                placeholder={t('class_manager.users.choose_student_category')}
                value={filters.userType}
              />
            </Col>
          </Row>
        </Container>

        {showModal && (
          <ModalClass
            type={modalTypes.transferStudents.type}
            onCancel={this.onModalCancel}
            onConfirm={this.onModalConfirm}
          />
        )}
      </div>
    );
  }

  renderUsersAmount() {
    const { pagination, t } = this.props;
    const { totalElements } = pagination;

    const qtd = totalElements > 0 ? Number.format(totalElements) : '';
    const label = t('general.student', { amountToPluralize: totalElements });

    return `${qtd} ${totalElements > 0 ? label.toLowerCase() : label}`;
  }
  // #endregion
}

export default ClassUsersHeader;
